import type { SVGProps } from 'react';
const SvgFeaturedPlayList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#featured_play_list_svg__a)">
      <path
        fill="currentColor"
        d="M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm-9 8H3V9h9v2Zm0-4H3V5h9v2Z"
      />
    </g>
    <defs>
      <clipPath id="featured_play_list_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFeaturedPlayList;
